import axiosConfig from './axiosConfig';

export const categoryApi = {
    getExpenseCategories: async () => {
        const response = await axiosConfig.get('/categories/expenses');
        return response.data;
    },

    getProjectStatuses: async () => {
        const response = await axiosConfig.get('/categories/project-statuses');
        return response.data;
    },

    getPriorityLevels: async () => {
        const response = await axiosConfig.get('/categories/priorities');
        return response.data;
    },

    getUserRoles: async () => {
        const response = await axiosConfig.get('/categories/user-roles');
        return response.data;
    },

    getAllCategories: async () => {
        const response = await axiosConfig.get('/categories/all');
        return response.data;
    },
};